<template>
    <div class="head">
        <div class="left-timer">{{ timer }}</div>
        <div class="head-title">
            <img src="../../assets/j-logo.png" alt="" class="j-logo" v-if="+rolelevel < 2 && !isFirst">
            {{ title1 }}
            <div v-if="title2" class="head-title2">{{ title2 }}</div>
        </div>
        <div class="large" @click="screen">
            <img src="@/assets/temimg2/screen.png" alt="">
        </div>
        <img src="@/assets/temimg15/header-ani.png" class="head-ani" alt="">
    </div>
</template>

<script>
import moment from 'moment';
import screenfull from 'screenfull'

export default {
    name: 'headtitle.temhead7',
    props: {
        title: {
            type: String,
            default: '设备信息化大屏展示'
        },
        rolelevel: {
            type: [String, Number],
            default: -1
        },
        isFirst: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            timer: '',
            title1: '',
            title2: ''
        }
    },
    mounted() {
        this.gettime()
        this.settitle()
    },
    methods: {
        gettime() {
            this.timer = moment().format('yyyy年MM月DD日  HH:mm:ss');
            setTimeout(() => {
                this.gettime()
            }, 100);
        },
        screen() {
            // 如果不允许进入全屏，发出不允许提示
            if (!screenfull.enabled) {
                // this.$message("您的浏览器不能全屏")
                return false
            }
            screenfull.toggle()
            // this.$message.success("全屏啦")
        },
        settitle() {
            if (this.title.includes('/n')) {
                let titlelist = this.title.split('/n')
                this.title1 = titlelist[0]
                this.title2 = titlelist[1]
            } else {
                this.title1 = this.title
            }
        }
    },
    watch: {
        title(n) {
            this.settitle()
        }
    }
}
</script>

<style lang="scss" scoped>
.head {
    width: 1920px;
    height: 199px;
    background: url(@/assets/temimg15/header.png) no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    position: relative;
    z-index: 401;
    pointer-events: none;
    margin-bottom: 24px;
    .head-title {
        font-family: 'pmzd';
        font-weight: 400;
        font-size: 44px;
        color: #FFFFFF;
        text-shadow: 0px 8px 14px rgba(255,255,255,0.69);
        // text-shadow: 0px 1px 6px rgba(0,0,0,0.48);
        position: relative;
        line-height: 44px;
        padding-top: 16px;
        text-align: center;
    }
    .head-title2 {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 20px;
        color: #FFFFFF;
        line-height: 20px;
    }
    .j-logo {
        position: absolute;
        width: 60px;
        height: 36px;
        left: -60px;
    }
    .left-timer {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 20px;
        color: #FFFFFF;
        line-height: 15px;
        font-style: italic;
        position: absolute;
        left: 64px;
        top: 40px;
        text-shadow: 0 0 10px rgba(41, 81, 202, .8), 0 0 10px rgba(41, 81, 202, .8), 0 0 10px rgba(41, 81, 202, .8);
    }
    .large {
        position: absolute;
        right: 64px;
        top: 25px;
        cursor: pointer;
        pointer-events: auto;
        img {
            width: 46px;
            height: 46px;
        }
    }
    .head-ani {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
    }
}
</style>